import React from 'react';

export const FullScreen: React.FC<React.HTMLAttributes<SVGElement>> = (
  props
) => (
  <svg
    width="22.65"
    height="22.65"
    viewBox="0 0 22.65 22.65"
    stroke="currentColor"
    strokeWidth="0.65"
    {...props}
  >
    <g transform="translate(0.325 0.325)">
      <path className="a" d="M7.123,0H0V7.123H.791V.791H7.123Zm0,0" />
      <path
        d="M310.332,7.123h.791V0H304V.791h6.332Zm0,0"
        transform="translate(-289.123)"
      />
      <path
        d="M.791,304H0v7.123H7.123v-.791H.791Zm0,0"
        transform="translate(0 -289.123)"
      />
      <path
        d="M311.123,304h-.791v6.332H304v.791h7.123Zm0,0"
        transform="translate(-289.123 -289.123)"
      />
    </g>
  </svg>
);
